import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import {shortcutIconColors} from 'src/components/elements/home/ShortcutButton';

const ScanProductShortcut = () => (
  <Svg width={24} height={24} viewBox="0 0 24 24" fill="none">
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 15.54V19a1 1 0 001 1h3.335v3H5a4 4 0 01-4-4v-3.46h3zM8.335 4H5a1 1 0 00-1 1v3.206H1V5a4 4 0 014-4h3.335v3zM20 8.206V5a1 1 0 00-1-1h-3.332V1H19a4 4 0 014 4v3.206h-3zM15.668 20H19a1 1 0 001-1v-3.46h3V19a4 4 0 01-4 4h-3.332v-3z"
      fill={shortcutIconColors().primaryColor ?? '#0052BF'}
    />
    <Path
      d="M6.092 8a.842.842 0 00-.842.842v6.316a.842.842 0 001.684 0V8.842A.842.842 0 006.092 8zM9.04 8a.842.842 0 00-.843.842v3.368a.842.842 0 101.684 0V8.842A.842.842 0 009.04 8zM11.987 8a.842.842 0 00-.842.842v3.368a.842.842 0 001.684 0V8.842A.842.842 0 0011.987 8zM14.934 8a.842.842 0 00-.842.842v3.368a.842.842 0 101.684 0V8.842A.842.842 0 0014.934 8zM9.04 13.895a.842.842 0 00-.843.842v.42a.842.842 0 001.684 0v-.42a.842.842 0 00-.842-.842zM11.987 13.895a.842.842 0 00-.842.842v.42a.842.842 0 001.684 0v-.42a.842.842 0 00-.842-.842zM14.934 13.895a.843.843 0 00-.842.842v.42a.842.842 0 101.684 0v-.42a.842.842 0 00-.842-.842zM18.723 15.158V8.842a.842.842 0 10-1.684 0v6.316a.842.842 0 001.684 0z"
      fill={shortcutIconColors().secondaryColor ?? '#58C6BB'}
    />
  </Svg>
);
export default ScanProductShortcut;
